import React, { useState } from "react";
import Swal from "sweetalert2";
import useCeo from "../../hooks/useCEO";
import { useCarga } from "../../hooks/useCarga";
import { Loader } from "../../components/Loader";
import TPT from "./../../assets/img/eyeTP.png";
import {
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CargaArchivos = () => {
  const [loading, setLoading] = useState(false);
  const [validate, setValidate] = useState(true);
  const [fileCollection, setFileCollection] = useState([]);
  const [listaUpload, setListaUpload] = useState([]);
  const { postCarga } = useCarga();

  useCeo({
    title: "Carga de archivos",
    description: "Carga de archivo",
  });

  // Manejar el cambio de archivos seleccionados con validación
  const onFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
      "application/vnd.ms-excel", // xls
      "text/csv", // csv
    ];
    const maxSize = 30 * 1024 * 1024; // 30 MB
    const invalidFiles = [];

    // Validar tipo y tamaño de archivos
    const filteredFiles = files.filter((file) => {
      if (!validTypes.includes(file.type)) {
        invalidFiles.push(`Tipo no permitido: ${file.name}`);
        return false;
      }
      if (file.size > maxSize) {
        invalidFiles.push(`Archivo demasiado grande: ${file.name}`);
        return false;
      }
      return true;
    });

    if (invalidFiles.length > 0) {
      setValidate(false);
      Swal.fire({
        title: "Error en la validación",
        html: invalidFiles.join("<br>"),
        icon: "info",
      });
      return;
    } else {
      setValidate(true);
    }

    setFileCollection(filteredFiles); // Solo archivos válidos se agregan
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();

    fileCollection.forEach((file) => {
      formData.append("fileCollection", file);
    });

    const resp = await postCarga(formData);
    setLoading(false);

    if (!resp.ok) {
      return Swal.fire({
        title: "Lo siento!",
        text: resp.msg,
        icon: "info",
      });
    }

    const uploadedFiles = fileCollection.map((file) => file.name);
    setListaUpload(uploadedFiles);

    Swal.fire({
      title: "¡Completado!",
      text: resp.msg,
      icon: "success",
    });
  };

  return (
    <>
      {loading && <Loader />}
      <div className="card w-75 container p-4">
        <h5 className="card-title">Subir archivos</h5>
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <input
              type="file"
              name="fileCollection"
              className="form-control"
              onChange={onFileChange}
              multiple
              required
            />
          </div>
          <br />
          <h5 className="pt-1 text-end">
            Solo se permiten archivos xls, xlsx y csv. Tamaño máximo de los
            archivos es de 30MB.
          </h5>
          <br />
          <button
            disabled={validate ? false : true}
            className="btn btn-outline-success"
            type="submit"
          >
            Cargar archivo(s)
          </button>
        </form>

        <ul className="mt-4">
          {listaUpload.map((img, index) => (
            <li key={index}>{img}</li>
          ))}
        </ul>
        <div className="container">
          <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
            <div className="col-md-4 d-flex align-items-center">
              <a
                href="https://totalprotect.mx"
                className="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1"
                aria-label="Total Protect"
              >
                <img src={TPT} alt="Total Protect" width="15" height="auto" />
              </a>

              <span className="mb-3 mb-md-0 text-body-secondary">
                &copy; 2026 Total Protect, Inc
              </span>
            </div>

            <ul className="nav col-md-8 justify-content-center list-unstyled d-flex gap-4 mt-3">
             {/* <li>
                <a
                  href="/aviso-de-privacidad"
                  className="text-body-secondary d-flex align-items-center gap-2"
                >
                  <FontAwesomeIcon icon={faFileContract} />
                  <span>Terminos y condiciones</span>
                </a>
              </li> */}

              {/* <li>
                <a
                  href="/aviso-de-privacidad"
                  className="text-body-secondary d-flex align-items-center gap-2"
                >
                  <FontAwesomeIcon icon={faUserShield} />
                  <span>Aviso de Privacidad</span>
                </a>
              </li> */}
            </ul>
          </footer>
        </div>
      </div>
    </>
  );
};
